/**
 * Load required plugin.
 */
import "../../../collapseNav/collapseNav";

/**
 * Configure the plugin.
 */

+function ($) {
    page.registerVendor('CollapseNav');

    page.initCollapseNav = function () {
        $('.navbar-mobile .nav-navbar[data-collapse-nav]').collapseNav({
            responsive: 1,
            mobile_break: 768,
            more_text: collapseNavMore + ' <span class="arrow"></span>',
            li_class: 'nav-item',
            li_a_class: 'nav-link',
            li_ul_class: 'nav'
        });
    }
}(jQuery);



